export default "__VITE_PUBLIC_ASSET__12d96569__"